export const PRIORITY_TO_COLOR_MAPPING = {
  1: '#F48B92',
  2: '#FFC649',
  3: '#639DDC',
  4: '#00010E'
};

export const STATUS_TO_COLOR_MAPPING = {
  'ap-south-1': '#CC3300'
};

export const IP_TO_URL_COLOR_MAPPING = {
  IP: '#B45CFA',
  URL: '#F3B925'
};

export const CAT_VS_UNCAT_COLOR_MAPPING = {
  CAT: '#258CF3',
  UNCAT: '#394149'
};

export const FE_TO_API_DISPUTE_MAPPING = {
  id: 'id',
  priority: 'priority',
  url: 'host',
  currentCategory: 'disputed_category',
  suggestedCategory: 'requested_category',
  updatedCategory: 'reviewed_category',
  requestDate: 'accepted_at',
  status: 'status',
  completedDate: 'updated_at'
};

export const API_TO_FE_DISPUTE_MAPPING = {
  id: 'id',
  priority: 'priority',
  host: 'url',
  disputed_category: 'currentCategory',
  requested_category: 'suggestedCategory',
  reviewed_category: 'updatedCategory',
  accepted_at: 'requestDate',
  status: 'status',
  updated_at: 'completedDate'
};

export const DRAWER_WIDTH = 180;
